<template>
  <v-dialog v-model="dialog" max-width="600px" @click:outside="closeDialogProdotto">
    <v-card min-height="500px">
      <v-card-title>
        <span class="text-h5">Aggiungi elemento a distinta</span>
      </v-card-title>
      <v-card-text>
        <v-tabs v-model="tab" @change="onChangeTab">
          <v-tab key="prodotto">Prodotto</v-tab>
          <v-tab key="multiselect" v-if="editedItem.livello > 0">Selezione</v-tab>
          <v-tab key="parametro" v-if="editedItem.livello > 0">Parametro</v-tab>
          <v-tab key="nota" v-if="editedItem.livello > 0">Nota</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" class="mt-5">
          <v-tab-item key="prodotto">
            <v-card flat>
              <v-card-text>
                <v-container>          
                  <v-row>        
                    <v-col cols="12" sm="12" md="12">
                      <component :is="'pProdotto'" :item="itemCodice(editedItem)" :index="0" @change="componentValueChange" :updateTrigger="trigger" :solo="false" :suTable="true" :isLotto="soloProdottiConLotto" :isBom="false" :isProdottoBase="soloProdottiBase" :clearInfo="locClearInfo" :popolaInfo="popolaInfo"/>
                    </v-col>
                  </v-row>            
                  <v-row> 
                    <v-col cols="12" sm="12" md="3">
                      <v-text-field v-model="editedItem.quantita" label="Quantità" flat :rules="[numerico]" @change="onChangeQuantita"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="3" class="mt-5 font-weight-medium">
                      {{ editedItem.unitaMisura }}
                    </v-col>                    
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item key="multiselect">
            <v-card flat>
              <v-card-text>
                <v-row>        
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedItem.descrizione" label="Elenco" flat></v-text-field>
                  </v-col>
                </v-row>  
                <v-row dense>        
                  <v-col cols="12" sm="12" md="9">
                    <v-text-field v-model="valore" label="Aggiungi valore" flat @keypress="onKeyPress"></v-text-field>
                  </v-col>
                  <v-col><v-btn title="Aggiungi" @click="addValore" class="mt-3 ml-2">Aggiungi</v-btn></v-col>
                </v-row>  
                <v-simple-table dense class="mt-1">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">VALORI</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in editedItem.valori" :key="index">
                        <td>{{ item }}</td>
                        <td><v-btn icon @click.stop="deleteValore(index)" title="Cancella l'elemento"><v-icon small>mdi-delete</v-icon></v-btn></td>
                      </tr>
                    </tbody>                
                  </template>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item key="parametro">
            <v-card flat>
              <v-card-text>
                <v-container>          
                  <v-row>        
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field v-model="editedItem.descrizione" label="Parametro" flat></v-text-field>
                    </v-col>
                  </v-row>            
                  <v-row> 
                    <v-col cols="12" sm="12" md="4">
                      <v-text-field v-model="editedItem.valore" label="Valore" flat></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item key="nota">
            <v-card flat>
              <v-card-text>
                <v-container>          
                  <v-row> 
                    <v-col cols="12" sm="12" md="12">
                      <v-textarea v-model="editedItem.descrizione" label="Nota" solo></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
<!--         <v-container>          
          <v-row>        
            <v-col cols="12" sm="12" md="12">
              <component :is="'pProdotto'" :item="itemCodice(editedItem)" :index="0" @change="componentValueChange" :updateTrigger="trigger" :solo="false" :suTable="true" :isLotto="true" :isProdottoBase="true" :clearInfo="clearInfo" :popolaInfo="popolaInfo"/>
            </v-col>
          </v-row>            
          <v-row> 
            <v-col cols="12" sm="12" md="4">
              <v-text-field v-model="editedItem.quantita" label="Quantità" flat :rules="[numerico]" @change="onChangeQuantita"></v-text-field>
            </v-col>
          </v-row>
        </v-container> -->
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeDialogProdotto">Annulla</v-btn>
        <v-btn color="blue darken-1" text @click="saveDialogProdotto">Salva</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import * as dot from 'dot-object'
  import pProdotto from './elementi/prodotto'
  export default {
    components: {
      pProdotto
    },
    props: {
      showDialog: Boolean,
      editedItem: Object,
      clearInfo: { type: Number, default: 1 },
      popolaInfo: { type: Number, default: 1 }      
    },
    data () {
      return {
        tab: 0,
        dialog: false,
        numerico: value => !isNaN(value) || 'Il valore deve essere numerico',
        trigger: 1,
        locClearInfo: 1,
        valore: '',
        soloProdottiConLotto: false, // TODO: Da impostazioni
        soloProdottiBase: true // TODO: Da impostazioni
      }
    },
    watch: {
      showDialog(value) {
        if (value) {
          this.tab = ['prodotto', 'multiselect', 'parametro','nota'].indexOf(this.editedItem.tipo)
          this.dialog = true
        }
      },
      clearInfo() {
        this.locClearInfo++
      }
    },
    methods: {
      onKeyPress(event) {
        if (event.code === 'Enter') {
          this.addValore()
        }
      },
      deleteValore(index)  {
        this.editedItem.valori.splice(index, 1)
      },
      addValore() {
        this.editedItem.valori.push(this.valore)
        this.valore = ''
        console.log(this.editedItem.valori)
      },
      onChangeTab() {
/*         this.editedItem.codice = ''
        this.editedItem.descrizione = ''
        this.editedItem.valore = ''
        this.editedItem.quantita = ''
        this.locClearInfo++ */
      },
      onChangeQuantita() {
        this.editedItem.quantita = +parseFloat(this.editedItem.quantita).toFixed(2)
      },
      closeDialogProdotto() {
        this.dialog = false
        this.$emit('aggiornaProdotto', null)
      },      
      saveDialogProdotto() {
          this.editedItem.tipo = ['prodotto', 'multiselect', 'parametro','nota'][this.tab]
          this.$emit('aggiornaProdotto', this.editedItem)
          this.closeDialogProdotto() 
      },
      itemCodice(item) {
        // console.log('itemcodice', item.codice)
        return {
          "model": "codice",
          "valueField": "codice",
          "label": "Codice Prodotto",
          "type": "Prodotto",
          "required": false,
          "hint": "descrizione",
          "readOnly": true,
          "addForbidden": true,
          value: (item && item.codice) || ''
        }
      },
      async componentValueChange(data) {
        // console.log('componentValueChange', data.model)
        const { model, subModel, value, decimals, index } = data
        let tgt = {}
        if (subModel) {
          let vv = value[subModel]
          if (decimals >= 0) {s
            vv = +parseFloat(vv).toFixed(decimals)
          }
          dot.str(model, vv, tgt)
        } else {
          let vv = value
          if (decimals >= 0) {
            vv = +parseFloat(vv).toFixed(decimals)
          }
          dot.str(model, vv, tgt)
        }
        _.merge(this.editedItem, tgt)
        await this.aggiornaCorrelati(data)
      },
      async aggiornaCorrelati(data) {
        switch (data.model) {
          case 'codice':
            if (data.value !== undefined) {
              this.editedItem.descrizione = _.get(data, 'item.descrizione', '')
              this.editedItem.unitaMisura = _.get(data, 'item.item.magazzino.unitaMisura', '')
              this.editedItem.richiedeLotto = _.get(data, 'item.item.isLotto', false)
              this.trigger++
            }
            break
          default:
            break
        }
      }      
    }
  }
</script>
